export default __webpack_public_path__ + "static/mobile_5-32c56ca654dfed7022f4700e60924b43.webp";